<template>
  <div class="vx-row">
    <vx-card title="Device Registration" class="mb-4">
      <div class="w-full flex flex-no-wrap">
        <div class="w-1/4 p-4">
          <span>Serial Number</span>
        </div>
        <div class="w-3/4 p-4">
          <vs-input
            id="txt-serial-number"
            class="w-full"
            v-model="data.serial_number"
            placeholder="Serial Number"
            v-validate="'required'"
            name="Serial Number"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Serial Number')"
          >{{ errors.first('Serial Number') }}</span>
        </div>
      </div>
      <div class="w-full flex flex-no-wrap">
        <div class="w-1/4 p-4">
          <span>Device Type</span>
        </div>
        <div class="w-3/4 p-4">
          <v-select id="cbo-device-type" inputId="txt-device-type" v-model="selected_type" name="device type" v-validate="'required'" placeholder="Select device type" :options="device_type"></v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('device type')"
          >{{ errors.first('device type') }}</span>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div class="w-full text-right">
        <vs-button id="btn-cancel" color="warning" @click="backPage">Cancel</vs-button>
        <vs-button id="btn-submit" class="ml-4" @click.prevent="submitForm">Submit</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import AxiosCall from "@/global/AxiosCall";
import vSelect from 'vue-select'
import { url } from "@/configs/apiUrl";

export default {
  name: "DeviceRegistration",
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      data: {
        id: "",
        device_type_id: "",
        serial_number: ""
      },
      device_type: [],
      selected_type:null
    };
  },

  created() {

  },
  methods: {
    backPage() {
      this.$router.push({name:'DeviceList'});
    },
    openLoading() {
      this.$vs.loading({
        type: "default"
      });
    },
    warning(title, text) {
      this.$vs.notify({
        title: title,
        text: text,
        color: "warning",
        position: "top-right"
      });
    },
    danger(title, text) {
      this.$vs.notify({
        title: title,
        text: text,
        color: "danger",
        position: "top-right"
      });
    },
    validateform(){
      return (!this.errors.any() &&
              this.device_type_id !== "" &&
              this.serial_number !== ""
      )
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.openLoading();
          // if form have no errors
          let user = JSON.parse(localStorage.getItem("userInfo")).displayName;
          let payload = this.data;
          payload.device_type_id = this.selected_type.id
          payload.user_action = user;
          if (this.data.id !== "" && this.data.id !== undefined) {
            AxiosCall.Put(url.svd.device.store + "/" + this.data.id, payload)
              .then(resp => {
                if (resp.code == 200) {
                  this.$vs.loading.close();
                  let status = true;
                  this.$store.dispatch('createAuditTrail', {
                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                    session_id: parseInt(localStorage.getItem('sessID')),
                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                    menu:      "Device Registration",
                    activity: "Update Device",
                    data_before: this.$store.state.current_device_data,
                    data_after: payload,
                  })
                  this.$router.push({
                    name: "DeviceList",
                    params: { status: status }
                  });
                } else {
                  this.$vs.loading.close();
                  this.danger("Update device", "Update device failed");
                }
              })
              .catch(e => {
                console.log(e);
                this.$vs.loading.close();
                this.danger("Update device", "Update device fail");
              });
          } else {
            delete payload.id;
            AxiosCall.Post(url.svd.device.store, payload)
              .then(resp => {
                //console.log(resp)
                if (resp.code == 200) {
                  this.$vs.loading.close();
                  let status = true;
                   this.$store.dispatch('createAuditTrail', {
                    user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                    session_id: parseInt(localStorage.getItem('sessID')),
                    user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                    menu:      "Device Registration",
                    activity: "Add Device",
                    data_after: resp.data
                  })
                  this.$router.push({
                    name: "DeviceList",
                    params: { status: status }
                  });
                } else {
                  this.$vs.loading.close();
                  this.danger("Add device", resp.message);
                }
              })
              .catch(e => {
                console.log(e);
                this.$vs.loading.close();
                this.danger("Add device", e.response.data.message);
              });
          }
        }else{
          if (!this.validateform()){
            if (this.data.serial_number === ""){
              this.warning("Serial Number", "Please fill serial number");
            }

            if (this.data.device_type_id === ""){
              this.warning("Device Type", "Please select device type")
            }
          }
        }
      });
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined) {
      AxiosCall.Get(url.svd.device.detail + "/" + this.$route.params.id).then(
        response => {
          this.data = response.data;
          AxiosCall.Get(url.svd.device_type.selection)
                  .then(response => {
                    if (response.code == 200) {
                      for(let data of response.data){
                        data.label = data.name
                        delete data.name
                        if (this.data.device_type_id === data.id){
                          this.selected_type = {id:this.data.device_type_id, label:data.label}
                        }
                        this.device_type.push(data)
                      }

                    } else {
                      this.warning("Get device type", "Fail get device type");
                    }
                  })
                  .catch(() => {});

        }
      );
    }else{
      AxiosCall.Get(url.svd.device_type.selection)
              .then(response => {
                if (response.code == 200) {
                  for(let data of response.data){
                    data.label = data.name
                    delete data.name
                    this.device_type.push(data)
                  }

                } else {
                  this.warning("Get device type", "Fail get device type");
                }
              })
              .catch(() => {});
    }
    let clearComboDeviceSelection = document.getElementsByClassName("vs__clear")
    if (clearComboDeviceSelection[0]!==undefined) {
      clearComboDeviceSelection[0].id="btn-clear-cbo-device-selection"
    }
    let selectNone = document.getElementsByClassName("vs__open-indicator")
    if (selectNone[0]!==undefined) {
      selectNone[0].id = "select-none-cbo-device-type"
    }
  },
  updated() {
    document.getElementById("txt-device-type").onclick = function(){
      let ul = document.getElementsByClassName("vs__dropdown-menu")
      if (ul[0] !== undefined) {
        ul[0].id = "ul-cbo-device-type"
      }
      let li = document.getElementsByClassName("vs__dropdown-option")
      if (li !== undefined) {
        if (li.length > 0) {
          let i
          for (i = 0; i < li.length; i++) {
            li[i].id = "li-cbo-device-type-"+i
          }
        }
      }
    }

    document.getElementById("select-none-cbo-device-type").onclick = function() {
      let ul = document.getElementsByClassName("vs__dropdown-menu")
      if (ul[0] !== undefined) {
        ul[0].id = "ul-cbo-device-type"
      }
      let li = document.getElementsByClassName("vs__dropdown-option")
      if (li !== undefined) {
        if (li.length > 0) {
          let i
          for (i = 0; i < li.length; i++) {
            li[i].id = "li-cbo-device-type-"+i
          }
        }
      }
    }

  },
  props: {
    id_merchant: {
      type: Number
    }
  }
};
</script>

<style scoped>
</style>